var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-menu',{attrs:{"default-openeds":_vm.defaultOpeneds,"router":true,"default-active":_vm.defaultActive}},[_vm._l((_vm.data),function(menu){return [(!_vm.isHidden(menu))?_c('SubMenu',{key:menu.path,attrs:{"menu":menu}}):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }